module.exports = __webpack_public_path__ + "img/logo-controlf5.9ecc0e83.png";